import { lazy } from "react";

import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const SamplesPage = lazy(() => import("@/pages/comercial-avancado/samples-page").then((m) => ({ default: m.SamplesPage })));
const QuotesPage = lazy(() => import("@/pages/comercial-avancado/quotes-page").then((m) => ({ default: m.QuotesPage })));
const SalesCockpitPage = lazy(() => import("@/pages/comercial-avancado/cockpit-page").then((m) => ({ default: m.SalesCockpitPage })));

const SAMPLES_READ = { access: "permission" as const, entity: "samples", action: "READ" };
const QUOTES_READ = { access: "permission" as const, entity: "quotes", action: "READ" };
const SALES_COCKPIT_READ = { access: "permission" as const, entity: "sales_cockpit", action: "READ" };

export const comercialAvancadoRoutes: RouteConfig[] = [
  { path: ROUTES.COMERCIAL_AVANCADO.COCKPIT, component: SalesCockpitPage, layout: "dashboard", permissions: SALES_COCKPIT_READ },
  { path: ROUTES.COMERCIAL_AVANCADO.SAMPLES, component: SamplesPage, layout: "dashboard", permissions: SAMPLES_READ },
  { path: ROUTES.COMERCIAL_AVANCADO.QUOTES, component: QuotesPage, layout: "dashboard", permissions: QUOTES_READ },
];
